<script setup lang="ts">
import { computed } from "vue";
import { getExtLinks } from "@/helpers/commonHelpers";

import FooterComponent from "@/components/FooterComponent.vue";

const props = withDefaults(
  defineProps<{
    type?: "no-permission" | "unavailable"
  }>(),
  {
    type: "no-permission"
  }
);

const title = computed(() => {
  switch (props.type) {
    case "unavailable":
      return "This page is unavailable";
    default:
      return "Access denied"
  }
});
const subTitle = computed(() => {
  switch (props.type) {
    case "unavailable":
      return "You currently don't have access to this section.";
    default:
      return "Sorry, only admins can view this page"
  }
});

const buttonsVisible = computed(() => props.type === "no-permission");

const profileUrl = computed(() => getExtLinks().userProfileBaseUrl);
</script>

<template>
  <div class="b-denied">
    <div class="b-denied__ico">
      <img src="/images/access-denied/illustration.svg" />
    </div>
    <div class="b-denied__text">
      <h1 id="accessDenied_title">{{ title }}</h1>
      <h2 id="accessDenied_subTitle">{{ subTitle }}</h2>
    </div>
    <div v-if="buttonsVisible" class="b-denied__wrap">
      <div class="b-denied__item">
        <h3 id="accessDenied_overviewTitle">View Admins &amp; Available Licenses</h3>
        <div>
          <RouterLink :to="{ name: 'Overview' }" class="wds-btn _large _secondary" id="accessDenied_overviewLink">
            Overview<img src="/images/access-denied/arrow-right.svg" />
          </RouterLink>
        </div>
      </div>
      <div class="b-denied__item">
        <h3 id="accessDenied_gotoProfileTitle">Go to Personal Profile</h3>
        <div>
          <a :href="profileUrl" class="wds-btn _large _secondary" id="accessDenied_gotoProfileLink">
            Profile<img src="/images/access-denied/arrow-right.svg" />
          </a>
        </div>
      </div>
    </div>
  </div>
  <FooterComponent />
</template>
